/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PgsseAction from 'pgsse/action/PgsseAction'
import { useParams } from 'react-router'
import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'
import { getLabel } from 'utils/StoreUtils'
import Form from './phase1/form/Form'
import { Accordion, AccordionDetails, AccordionSummary, Stack } from '@mui/material'
import { isNil, keys, orderBy, uniq } from 'lodash'
import ProgressCard from 'components/card/ProgressCard'

const DiagnosticFormsApp = () => {
    const dispatch = useDispatch()
    const { idDiagnostic } = useParams()
    const [forms, setForms] = useState([])
    const [surveys, setSurveys] = useState({})

    const {
        installations,
        contributors,
    } = useSelector(store => ({
        installations: store.InstallationReducer.installationsLight,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    useEffect(() => {
        if (isNil(installations)) return
        PgsseAction.fetchDiagnosticForms(idDiagnostic).then(json =>
            setForms(json.map(form => {
                if (form.stationType !== STATION_TYPE_CONSTANT.installation) return form
                const inst = installations.find(i => i.id === form.code)
                return { ...form, inst }
            })),
        )
    }, [dispatch, idDiagnostic, installations])

    useTitle(() => {
        return [{
            title: i18n.pgsse,
            href: PATH_PGSSE,
        }]
    }, [])

    useEffect(() => {
        if (!forms.length) return
        setSurveys([])
        const couples = uniq(forms.map(form => {
            if (form.stationType === STATION_TYPE_CONSTANT.installation) {
                return `${form.idSurvey}-${form.stationType}-${form.inst?.installationType}`
            }
            return `${form.idSurvey}-${form.stationType}-`
        }))
        couples.forEach(couple => {
            const [ idSurvey, stationType, installationType] = couple.split('-').map(d => parseInt(d))
            dispatch(PgsseAction.fetchSurvey(idSurvey, { stationType, installationType })).then((survey) => {
                setSurveys(prev => ({ ...prev, [couple]: survey }))
            })
        })
    }, [dispatch, forms])

    return (
        <Stack sx={{ padding: '10 10 10 20' }} spacing={1}>
            { (installations.length && keys(surveys).length && forms.length) ?
                orderBy(forms, ['stationType']).map(form => {
                    const title = !isNil(form.inst) ? getLabel([form.inst], form.code) : getLabel(contributors, form.code)
                    return (
                        <Accordion key={form.idForm}>
                            <AccordionSummary>{title}</AccordionSummary>
                            <AccordionDetails>
                                <Form
                                    title={title}
                                    form={form}
                                    installation={form.inst}
                                    survey={surveys[`${form.idSurvey}-${form.stationType}-${!isNil(form.inst) ? form.inst.installationType : ''}`]}
                                    isFormLoaded={!!forms.length}
                                    isSurveyLoaded={!!keys(surveys).length}
                                    readMode
                                />
                            </AccordionDetails>
                        </Accordion>
                    )
                }) : <ProgressCard indeterminate />
            }
        </Stack>
    )
}

DiagnosticFormsApp.propTypes = {
}

export default DiagnosticFormsApp
